import React, { useContext, useState, useEffect } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import ProjectService from '../../services/ProjectService';
import ProductService from '../../services/ProductService';
import EventService from '../../services/EventService';
import ProjectDetail from './ProjectDetail/ProjectDetail';
import ProductDetail from './ProductDetail';
import UserContext from '../../contexts/UserContext';
import { normalizeLink } from '../../utils';


export default function DetailPage(props) {
  const userContext = useContext(UserContext);
  const { id } = useParams();
  const [details, setDetails] = useState();
  const isPhausMember = userContext.currentUser?.phaus_member;

  const history = useHistory();

  const webLink = (event) => {
    const rawLink =
    isPhausMember && event.member_website_link
        ? event.member_website_link
        : event.website_link;

    const href = normalizeLink(rawLink);

    return (
      <a
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        className="cta-button remove-text-decoration width-50 m-a"
        style={{ margin: '0.5em' }}
      >
        Sign Up
      </a>
    );
  };

  useEffect(() => {
    if (props.type === 'project') {
      ProjectService.getProjectByID(id).then((project) => {
        project = project.project;
        setDetails(<ProjectDetail project={project} />);
      });
    } else if (props.type === 'product') {
      ProductService.getProductByID(id).then((product) => {
        console.log('PRODUCT', product);
        product = product.certified_product;
        setDetails(<ProductDetail product={product} />);
      });
    } else if (props.type === 'event') {
      EventService.getEventByID(id).then((event) => {
        event = event.event;
        console.log(event);
        setDetails(
          <div className='detailCard flex-column header-align-content'>
            <h2>{event.campaign_name}</h2>
            <table className='detailTable2'>
              <tbody>
                <tr>
                  <th>Format</th>
                  <td>{event.open_text}</td>
                </tr>
                <tr>
                  <th>Member Price</th>
                  <td>${event.member_price}</td>
                </tr>
                <tr>
                  <th>Non-Member Price</th>
                  <td>${event.non_member_price}</td>
                </tr>
                <tr>
                  <th>Location</th>
                  <td>{event.location}</td>
                </tr>
              </tbody>
            </table>
            <div className='flexbox-column'>
              {webLink(event)}
              <p>{event.description}</p>
            </div>
          </div>
        );
      });
    } else {
      setDetails(<div>There's nothing here!</div>);
    }
  }, [id, props]);

  return (
    <div className='card-container detailCardContainer'>
      <div className='detail-card-body card-body'>
        {details}
        <button
          onClick={() => history.goBack()}
          className='cta-button2 remove-text-decoration detailButton'
        >
          Go Back
        </button>
      </div>
    </div>
  );
}
